import React from "react";
import '../index.css';
import ShareableNav from "../components/ShareableNav";
import Shop from "../pages/Shop";
import config from '../config/config';
function EcommerceLayout(){
    return (
      <div className="flex flex-col min-h-screen">
      <style>{`
         @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=Quicksand:wght@400;500;600;700&display=swap');
       html,body{
        font-family: ${config.FONT_FAMILY}, sans-serif !important;
       }
        `}
        </style>
      <ShareableNav/>

      <main className="flex-grow">
        <Shop/>


      </main>
      </div>

    );
}

export default EcommerceLayout;